module.exports = __webpack_public_path__ + "img/typing-club.6512683f.webp";